/* eslint-disable no-nested-ternary */
import React, { useState, useMemo } from 'react'
import { Glyphicon } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useT, useLocale } from '@transifex/react'

import { groupBy } from '../../../common/utils'

import useSwrPagination from '../../../hooks/useSwrPagination'
import LockEventItem from './LockEventItem'
import LockEventTabs from './LockEventTabs'

const getEventsUrl = (lock, customer) => {
  if (lock) return `/subject/admin/events/lock/${lock._id}`

  if (customer) return `/subject/admin/events/customer/${customer._id}`

  return '/subject/admin/events'
}

const LockEvents = ({ lock, customer, filteredLockData }) => {
  const t = useT()
  const locale = useLocale()
  const [oldestEventIds, setOldestEventIds] = useState([])
  const groupedLocksById = useSelector((state) => !lock && groupBy(state.collectionData.locks, (l) => l._id))
  const groupedLocksByCarrierDoorId = useSelector(
    (state) =>
      !lock
      && groupBy(
        state.collectionData.locks.filter((l) => l.carrier_door),
        (l) => l.carrier_door._id
      )
  )
  const groupedLocksByStorage = useSelector(
    (state) =>
      !lock
      && groupBy(
        state.collectionData.locks.filter((l) => l.storage),
        (l) => l.storage._id
      )
  )
  const { isValidating, data: events } = useSwrPagination((lock || groupedLocksById.size > 0) && getEventsUrl(lock, customer), oldestEventIds.length + 1, { oldestIds: oldestEventIds })

  const [search, setSearch] = useState('')
  const [activeEventTypeTab, setActiveEventTypeTab] = useState('')

  const groupedEvents = useMemo(() => events && groupBy(events, (e) => e.type), [events])

  const filteredEvents = useMemo(() => {
    if (!events) return []
    if (filteredLockData && filteredLockData.length) return events.filter((e) => filteredLockData.includes(e.lock)) // filtering based on text search
    if (!activeEventTypeTab) return events

    return events.filter((event) => {
      if (!activeEventTypeTab) return true
      return event.type === activeEventTypeTab
    })
  }, [events, search])

  if (!events || (events.length === 0 && isValidating)) return <div style={{ textAlign: 'center', padding: 10 }}>{t('Loading...')}</div>

  if (events.length === 0) return <div style={{ textAlign: 'center', padding: 10 }}>{t('No events')}</div>

  return (
    <div style={{ background: lock || customer ? 'transparent' : '#FFF' }}>
      {lock && (
        <div className="flex" style={{ padding: 30, justifyContent: 'space-between' }}>
          <div className="flex inflate-search-events">
            <input type="text" style={{ marginTop: 5 }} value={search} onChange={(e) => setSearch(e.target.value)} placeholder={t('Search')} className="Sök" />
          </div>
          <LockEventTabs t={t} groupedEvents={groupedEvents} activeEventTypeTab={activeEventTypeTab} setActiveEventTypeTab={setActiveEventTypeTab} />
        </div>
      )}
      {filteredEvents.map((event) => {
        let foundLock = lock

        if (!foundLock) {
          ;[foundLock] = groupedLocksById.get(event.lock) || groupedLocksByCarrierDoorId.get(event.lock) || groupedLocksByStorage.get(event.storage || event.storageId) || []
        }

        return <LockEventItem key={event._id} locale={locale} t={t} event={event} lock={foundLock} shouldShowLockInfo={!lock && foundLock} search={search} />
      })}
      {events.length > 0 && (
        <div className="flex justify-content-center">
          {isValidating ? (
            <div style={{ padding: 10 }}>{t('Loading...')}</div>
          ) : events.length % 50 === 0 ? (
            <div onClick={() => setOldestEventIds([...oldestEventIds, events.slice(-1)[0]._id])} style={{ fontSize: '20px', marginTop: 10, marginBottom: 10, textAlign: 'center', cursor: 'pointer' }}>
              {t('Show more')}
              <Glyphicon glyph="glyphicon glyphicon-menu-down" />
            </div>
          ) : (
            <div style={{ marginBottom: 5 }} />
          )}
        </div>
      )}
    </div>
  )
}

export default LockEvents
